var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.11649 0.477051C1.47059 0.477051 0.132431 1.81521 0.132431 3.46111V4.95313H26.9889V3.46111C26.9889 1.81521 25.6508 0.477051 24.0049 0.477051H3.11649ZM26.9889 9.42922H0.132431V18.3814C0.132431 20.0273 1.47059 21.3654 3.11649 21.3654H24.0049C25.6508 21.3654 26.9889 20.0273 26.9889 18.3814V9.42922ZM5.35453 15.3973H8.33858C8.74889 15.3973 9.0846 15.733 9.0846 16.1433C9.0846 16.5536 8.74889 16.8894 8.33858 16.8894H5.35453C4.94422 16.8894 4.60851 16.5536 4.60851 16.1433C4.60851 15.733 4.94422 15.3973 5.35453 15.3973ZM10.5766 16.1433C10.5766 15.733 10.9123 15.3973 11.3226 15.3973H17.2907C17.7011 15.3973 18.0368 15.733 18.0368 16.1433C18.0368 16.5536 17.7011 16.8894 17.2907 16.8894H11.3226C10.9123 16.8894 10.5766 16.5536 10.5766 16.1433Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardIcon);
export default __webpack_public_path__ + "static/media/creditCardIcon.4d9223516235b15ba0a0ae383d50c988.svg";
export { ForwardRef as ReactComponent };